module.exports = __webpack_public_path__ + "static/media/22ESCWA10.30f77751.jpg";